export default __webpack_public_path__ + "static/media/Icons_Fund-fact-sheet.0db93255.svg";